import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Col, Row, Button } from 'react-bootstrap';

const body = (bodyText) => {
  if (bodyText) {
    return (
      <Modal.Body>
        {bodyText}
      </Modal.Body>
    );
  }
};

const checkbox = (checkboxText, retrigger, onCheckboxChange) => {
  if (checkboxText) {
    return (
      <div>
        <input
          id="only-show-concerning-checkbox"
          type="checkbox"
          checked={retrigger}
          onChange={e => onCheckboxChange(e.target.checked)}
          style={{ margin: '0 10px', verticalAlign: 'middle' }}
        />
        {checkboxText}
      </div>
    );
  }
};

const AcknowledgeBaselineUpdateModalComponent = ({
  visible,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  bodyText,
  checkboxText,
  onCheckboxChange,
  title,
  eventProps,
}) => (
  <Modal onHide={onCancel} show={visible}>
    <Modal.Header closeButton>
      <Modal.Title>
        {title}
      </Modal.Title>
    </Modal.Header>
    {body(bodyText)}
    {checkbox(checkboxText, eventProps.retrigger, onCheckboxChange)}
    <Modal.Footer>
      <Row>
        <Col md={6}>
          <Button
            id="submit-button"
            bsStyle="warning"
            block
            onClick={() => onConfirm(eventProps)}
          >
            {confirmText}
          </Button>
        </Col>
        <Col md={6}>
          <Button block onClick={onCancel}>
            {cancelText}
          </Button>
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
);


AcknowledgeBaselineUpdateModalComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string,
  checkboxText: PropTypes.string,
  onCheckboxChange: PropTypes.func.isRequired,
  eventProps:PropTypes.object,
};

export default AcknowledgeBaselineUpdateModalComponent;



// WEBPACK FOOTER //
// src/Components/AcknowledgeBaselineUpdateModalComponent.jsx